import { DateRangePicker as RangePicker } from "./DateRangePicker";
import { DropdownOptions } from "./DropdownOptions";
import { Root } from "./Root";

export const DateRangePicker = Object.assign(Root, {
  RangePicker,
  DropdownOptions,
});
